<template>
  <div class="nps">
    <h5 class="mb-3" v-html="question.the_question"></h5>
    <div class="d-flex flex-wrap">
      <div
        class="nps-button"
        v-for="answer in question.answers"
        :class="selectedClass(answer)"
        :key="answer.id"
      >
        {{ answer.the_answer }}
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { mapState } from 'pinia'
import { useSurveyResponseStore } from '@app/stores/SurveyResponseStore.ts'

export default {
  props: {
    question: { type: Object, required: true },
    recipient_id: { type: [Number, String], required: true },
  },
  computed: {
    ...mapState(useSurveyResponseStore, ['surveyResponses']),
    response() {
      return this.surveyResponses.find(
        (r) => r.question_id === this.question.id && r.recipient_id === Number(this.recipient_id),
      )
    },
  },
  methods: {
    selectedClass(answer) {
      return answer.the_answer == this.response?.value_answer ? 'selected' : ''
    },
  },
}
</script>
<style lang="sass" scoped>
h5
  line-height: 140%
  margin-bottom: 16px
.nps
  .nps-button
    &:hover
      cursor: default
</style>
